import { pp, link, app_state, pluralize } from '@helpers'
import { authStore } from '@stores'

export {
    arrayLast,
    getTabsOpened, getTabsOpenedNumber, setTabsOpened,
    counterInactivity,
    roles_list,
    // getToken,
    // log,
    toggleDark,
    toggleSquare,
    minutesToHours,
}

const arrayLast = (arr)=>{

// if (!Array.prototype.last){
    Array.prototype.last = function(){
        return arr[arr.length - 1];
    };
// };
}



/**
 * Count tabs opened with app connected
 * For message in Components/partials/UpgradeAppVersionUser.vue
 * @function setTabsOpened() call in js/app.js   (onBeforeMount())
 */
const getTabsOpened = () => {

	if (typeof localStorage !== 'undefined') {
		// localStorage is available
		return localStorage.getItem(app_state().tabsOpenKey)
	} else {
		return null
	}
}
const getTabsOpenedNumber = () => {
	return Number(getTabsOpened())
}
const setTabsOpened = () => {

	// define increment counter part
	const tabsOpen = getTabsOpened()
	// log('in helpers/others @setTabsOpened()',app_state().tabsOpenKey, tabsOpen)

	if (tabsOpen == null) {
        if (typeof localStorage !== 'undefined') {
			localStorage.setItem(app_state().tabsOpenKey, 1)
		}
	} else {
		localStorage.setItem(app_state().tabsOpenKey, parseInt(tabsOpen) + parseInt(1))
	}
}


const counterInactivity = ( /* store,  */ user) => {

    // log('in counterInactivity - user', user, this, pp() /* pp(), usePage()?.props?.value */)

    if (user) {

        // var user = options.user
        // var store = app.config.globalProperties.$store

        // var store       = options.store
        // var $q = options.$q//useQuasar//app.config.globalProperties.$q

        // var $$q = app.config.globalProperties.$q
        // var store = app.config.globalProperties.$store
        // var $$page = app.config.globalProperties.$page

        // var app_state   = store.state.app

        // log('in counterInactivity',   store, app_state/* , $$q, $$store, $$page */ )

        // $q.dialog({title:'Avertissement'})


        clearInterval(app_state().counter)

        app_state().count_minutes_without_inactivity = (pp()?.session_lifetime - 5) //? 60minutes  ---  65 in .env ---  (used in components/HeaderApp.vue)
        // app_state().count_minutes_without_inactivity = 1 //! TESTS

        app_state().counter = setInterval(() => {
            app_state().count_minutes_without_inactivity--

            // log('in counterInactivity', app_state().count_minutes_without_inactivity)

            // if(user && app_state().count_minutes_without_inactivity === 15){
            if (app_state().count_minutes_without_inactivity === 5) {
                // dialog before disconnect
                app_state().modalAutoDisconnect =
                    $q.dialog({
                        title: 'Avertissement',
                        persistent: true,
                        message: `Vous serez bientôt déconnecté(e) automatiquement.`,
                        ok: {
                            label: 'Déconnexion',
                            icon: 'logout'
                        },
                        cancel: {
                            label: 'Poursuivre',
                            iconRight: 'login',
                            outline: true
                        }
                    }).onOk(() => {
                        clearInterval(app_state().counter)
                        app_state().counter = null
                        // store.dispatch('auth/logout', true) // Vuex
                        authStore().logout(true)
                    }).onCancel(() => {
                        link()
                    })
            }
            if (app_state().count_minutes_without_inactivity === 0) {
                // auto Disconnect
                clearInterval(app_state().counter)
                app_state().modalAutoDisconnect?.hide()
                // if(user){
                app_state().counter = null
                // store.dispatch('auth/logout', true) // Vuex
                authStore().logout(true)
                // }
            }
        }, 60000)
        // },1000) //! other TESTS
    }
}

// roles_list()
const roles_list = () => {
    return [{
            name: 'master',
            fullname: 'WebMaster',
            id: 1
        },
        {
            name: 'admin',
            fullname: 'Administrateur',
            id: 2
        },
        {
            name: 'carrier',
            fullname: 'Transporteur',
            id: 3
        },
        {
            name: 'client',
            fullname: 'Client',
            id: 4
        },
        {
            name: 'driver',
            fullname: 'Chauffeur',
            id: 5
        },
    ]
}

/**
 * get token for QUploader
 * @returns {String} csrf token
 */
// const getToken = ()=>{
//     return document.head.querySelector('meta[name="csrf-token"]').content;
// }



// log vars passed - util in <templates>
// la fonction log() est dans bootstrap.js
// const log = (...vars) => log(...vars)




const toggleDark = () => {
    $q.dark.toggle()

    // $q.cookies.remove('dark_mode')
    $q.cookies.set('dark_mode', $q.dark.isActive, {
        path: '/',
        secure: true
    })
}


const toggleSquare = ()=>{
    var id = 'squared-scss'

    var link = document.getElementById(id)
    if(link){
        document.head.removeChild(link)
    }

    var newLink = document.createElement("link");

    newLink.id = id
    newLink.rel = 'stylesheet'


    newLink.href = '/css/'+(app_state().squared ? 'not-' : '')+'square.css' // files in public/css/

    app_state().squared = !app_state().squared

    $q.cookies.set('square_mode', app_state().squared, { path: '/', secure: true })

    document.head.appendChild(newLink)
}


// fonction transformant les minutes en heures, au besoin
const minutesToHours = (minutes, longText = false) => {
    if (isNaN(minutes) || minutes <= 0) {
        return longText ? '0 minute' : '0';
    }
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if(longText){
        var hText = pluralize(hours, 'heure')
        var mText = pluralize(remainingMinutes, 'minute')
		if(remainingMinutes > 0){
			return hours > 0 ? `${hText} et ${mText}` : `${mText}`;
		}
		return hours > 0 ? `${hText}` : '';
    }
    if(remainingMinutes > 0){
		return hours > 0 ? `${hours}h ${remainingMinutes}m` : `${remainingMinutes}m`;
	}
	return hours > 0 ? `${hours}h` : '';
}


// export default {

// showOverlay(){
//     proto.$store.state.app.show_overlay = true
// },
// hideOverlay(){
//     _.delay(()=>{
//         proto.$store.state.app.show_overlay = false
//     }, 150)
// },



/**
 * set value in Array into LocalStorage (for AutoComplete)
 */
// setInLocalStorage = function (key, val){

// 	var if_exist = this.$q.localStorage.getItem(key);

// 	if(if_exist){

// 		var in_array = (if_exist.indexOf(val) > -1);
// 		if(in_array){ return; }

// 		var v = if_exist
// 		v.push(val);
// 		this.$q.localStorage.set(key, v);
// 	} else {
// 		this.$q.localStorage.set(key, [val]);
// 	}
// },

/**
 * remove key in LocalStorage (for AutoComplete)
 */
// removeInLocalStorage = function (key){

// 	this.$q.localStorage.remove(key);
// },

/**
 * get value in LocalStorage (for AutoComplete)
 */
// getInLocalStorage: function (key, terms){
// 	var results = [];

// 	var items = this.$q.localStorage.getItem(key);

// 	if(items){
// 		results = _.filter(items, (v)=>{
// 			return v && v.indexOf(terms) > -1
// 		});
// 	}
// 	return results;
// },



//getNavigatorUserAgent: function(){
//	var userAgent = navigator.userAgent;
//	var nav = '?';
//	if		((/Firefox/gi)	.test(userAgent) ){ nav = 'Firefox'; }
//	else if ((/Chrome/gi)	.test(userAgent) ){ nav = 'Chrome'; }
//	else if ((/Chromium/gi)	.test(userAgent) ){ nav = 'Chromium'; }
//	else if ((/Safari/gi)	.test(userAgent) ){ nav = 'Safari'; }
//	else if ((/Edge/gi)		.test(userAgent) ){ nav = 'Edge'; }
//	else if ((/Opera/gi)	.test(userAgent) ){ nav = 'Opera'; }
//	return nav;
//},


// }
